<button type="button" class="btn btn-outline-dark" [disabled]="!disabled || loading" (click)="handleClick($event)">
  <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
  <ng-content></ng-content>
</button>
